<template>
  <FormationDetailLayout
    lesson="Formation VTC Initiale"
    back-item="formation-vtc"
    :hero-image="heroImage"
    hero-alt="time-laps-vtc"
    hero-eyebrow="Carte professionnelle VTC"
    hero-title="VTC INITIALE"
    :hero-stats="heroStats"
  >
    <template #main>
      <article class="formation-section formation-section--intro">
        <h2>Formation vtc initiale</h2>

        <div class="formation-flow">
          <p>
            La <strong>formation initiale</strong> pour
            <strong>devenir chauffeur VTC</strong> est une étape cruciale pour
            acquérir les compétences nécessaires dans ce domaine. Elle comprend
            un programme complet de cours qui couvrent différents aspects tels
            que la réglementation du
            <strong>transport public particulier de personnes</strong>, la
            gestion, la sécurité routière, ainsi que les compétences
            linguistiques en français et en anglais. La
            <strong>formation</strong> est dispensée sur une durée de 90 heures
            réparties sur 3 semaines, avec des horaires flexibles incluant des
            sessions en journée, en soirée et même le weekend. Un soutien
            financier est également proposé avec la possibilité d'utiliser le
            <strong>CPF</strong> (<strong>Compte Personnel de Formation</strong
            >) et la facilité de paiement en 3 fois sans frais. De plus, une
            voiture est mise à disposition pour l'<strong
              >examen pratique</strong
            >, et en cas d'échec à l'<strong>examen théorique</strong>, une
            deuxième chance est accordée. Cette <strong>formation</strong> vise
            à préparer les candidats de manière complète et efficace pour leur
            future <strong>carrière en tant que chauffeur VTC</strong>.
          </p>
        </div>

        <div class="formation-certification">
          <p class="formation-certification__copy">
            <strong>certification:</strong> RS5637 Habilitation pour l'accès à
            la profession de conducteur de voiture de transport avec chauffeur
            (VTC).<br />
            <strong>certificateur:</strong> MINISTÈRE DE LA TRANSITION
            ECOLOGIQUE, DE LA BIODIVERSITÉ, DE LA FÔRET, DE LA MER ET DE LA
            PECHE.<br />
            <strong>date d'enregistrement:</strong> 09-12-2021
          </p>
          <a
            href="https://www.francecompetences.fr/recherche/rs/5637/"
            class="formation-certification__link"
          >
            FRANCE compétences certification
          </a>
        </div>
      </article>

      <section class="formation-exams">
        <article class="formation-section formation-section--theory">
          <h2>Épreuves théoriques vtc</h2>

          <div class="formation-panel">
            <h3>5 épreuves théoriques "Tronc commun"</h3>

            <ul class="formation-list">
              <li>
                A – Réglementation du
                <strong>transport public particulier de personnes</strong>
                (coeff 3, note éliminatoire inférieure à 6/20)
              </li>
              <li>
                B – Gestion (coeff 2, note éliminatoire inférieure à 6/20)
              </li>
              <li>
                C - Sécurité routière (coeff 3, note éliminatoire inférieure à
                6/20)
              </li>
              <li>
                D – Capacité d'expression et de compréhension en langue
                française, sur la base d'un texte de 15 à 20 lignes (coeff 2,
                note éliminatoire inférieure à 6/20)
              </li>
              <li>
                E – Capacité d'expression et de compréhension en langue anglaise
                (coeff 1, note éliminatoire inférieure à 4/20)
              </li>
            </ul>

            <h4>2 épreuves spécifiques d'admissibilité</h4>

            <ul class="formation-list">
              <li>
                F(V) Connaissance du territoire et la réglementation locale
                (coeff 3, note éliminatoire inférieure à 6/20)
              </li>
              <li>
                G(V) Réglementation nationale de l'activité taxis ainsi que sur
                la gestion propre à l'activité (coeff 3, note éliminatoire
                inférieure à 6/20)
              </li>
            </ul>

            <div class="formation-panel__footer">
              <p>Méthode d'évaluation : QCM et QRC</p>
              <p>Seuil d'admissibilité : 10 / 20 (sans note éliminatoire)</p>
              <p>Validité de 1 an pour 3 présentations à l'examen pratique.</p>
            </div>
          </div>
        </article>

        <div class="formation-exams__stack">
          <article class="formation-section formation-section--practice">
            <h2>Examen pratique vtc</h2>

            <div class="formation-panel">
              <h3>Épreuves pratiques d'admission</h3>

              <ul class="formation-list">
                <li>
                  OBJECTIF : évaluer la capacité du candidat à assurer, par sa
                  conduite en circulation, la sécurité des passagers et des
                  autres usagers de la route tout en proposant aux clients un
                  service commercial de qualité.
                </li>
                <li>
                  Mise en situation pratique de réalisation d'une course de
                  taxi.
                </li>
              </ul>

              <ul class="formation-list formation-list--compact">
                <li>
                  Seuil d'admission à l'examen : 12 / 20 à l'<strong
                    >épreuve pratique</strong
                  >.
                </li>
              </ul>
            </div>
          </article>

          <ExamPrerequisitesCard mode="vtc" />
        </div>
      </section>

      <article class="formation-section formation-section--t3p">
        <h2>Examen t3p vtc</h2>
        <p>
          L'examen <strong>T3P</strong> (<strong
            >Transport Public Particulier de Personnes</strong
          >) est une étape essentielle pour
          <strong>obtenir la carte professionnelle de chauffeur VTC</strong>.
          Cet examen évalue les connaissances et compétences nécessaires pour
          exercer cette profession. Il comprend des
          <strong>épreuves théoriques</strong> portant sur la réglementation, la
          gestion, la sécurité routière et les compétences linguistiques. Les
          candidats doivent obtenir une note minimale de 10/20 aux épreuves
          théoriques et 12/20 à l'épreuve pratique pour réussir. Une préparation
          rigoureuse est recommandée pour réussir cet examen et obtenir la
          <strong>certification de chauffeur VTC</strong>.
        </p>
      </article>
    </template>
  </FormationDetailLayout>
</template>

<script>
import ExamPrerequisitesCard from "@/components/formations/ExamPrerequisitesCard.vue";
import FormationDetailLayout from "@/components/formations/FormationDetailLayout.vue";
import { useMeta } from "vue-meta";

const heroImage = require("@/assets/pictures/formation-vtc-initiale.webp");
const heroStats = [
  { label: "Prix", value: "1350€" },
  { label: "Durée", value: "Selon formule" },
  { label: "Voiture de prêt", value: "pour l'examen" },
  { label: "Financement", value: "Eligible CPF" },
  { label: "paiement", value: "3x sans frais" },
];

export default {
  name: "VtcInitiale",
  components: { ExamPrerequisitesCard, FormationDetailLayout },
  setup() {
    useMeta({
      title: "Devenir VTC",
      description: [
        {
          content:
            "Découvrez notre formation initiale VTC complète pour devenir un chauffeur VTC professionnel qualifié. Apprenez les compétences essentielles en matière de réglementation, de service client, de gestion et de conduite professionnelle.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.institut-taxi.fr/formation-vtc-initiale",
        },
      ],
    });
  },
  data() {
    return {
      heroImage,
      heroStats,
    };
  },
};
</script>
